import { useCloud } from "@dashboard/auth/hooks/useCloud";
import { Box, Text, Tooltip } from "@saleor/macaw-ui-next";
import { CloudIcon } from "lucide-react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { useEnvLink } from "./menu/hooks/useEnvLink";

export const MountingPoint = () => {
  const { isAuthenticatedViaCloud } = useCloud();
  const envLink = useEnvLink();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      display="flex"
      gap={3}
      paddingX={4}
      paddingY={4}
      alignItems="center"
      borderBottomWidth={1}
      borderBottomStyle="solid"
      borderColor="default1"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Logo mark */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        borderRadius={3}
        flexShrink="0"
        __width="34px"
        __height="34px"
        style={{
          background: "linear-gradient(135deg, #111827 0%, #1e3a5f 100%)",
          boxShadow: "0 2px 6px rgba(15, 23, 42, 0.30)",
        }}
      >
        <Text
          fontWeight="bold"
          style={{ color: "#ffffff", fontSize: "11px", letterSpacing: "0.01em" }}
        >
          JBM
        </Text>
      </Box>

      {/* Brand text */}
      <Box display="flex" flexDirection="column" style={{ gap: "1px" }} __flex="1">
        <Text
          size={4}
          fontWeight="bold"
          color="default1"
          style={{ lineHeight: "1.2", letterSpacing: "-0.02em" }}
        >
          JBM
        </Text>
        <Text
          size={1}
          color="default2"
          style={{ lineHeight: "1.2", letterSpacing: "0.04em", textTransform: "uppercase" }}
        >
          Dashboard
        </Text>
      </Box>

      {isAuthenticatedViaCloud && (
        <Tooltip>
          <Tooltip.Trigger>
            <Box
              as="a"
              href={envLink}
              target="_blank"
              rel="noopener noreferrer"
              display="flex"
              alignItems="center"
              color="default2"
              style={{
                opacity: isHovered ? 1 : 0,
                transition: "opacity 0.15s ease-in-out",
              }}
              data-test-id="cloud-environment-link"
            >
              <CloudIcon size={15} />
            </Box>
          </Tooltip.Trigger>
          <Tooltip.Content side="bottom">
            <Tooltip.Arrow />
            <Text size={2}>
              <FormattedMessage defaultMessage="Go to Saleor Cloud" id="EXqb2l" />
            </Text>
          </Tooltip.Content>
        </Tooltip>
      )}
    </Box>
  );
};
